import { FC } from 'react';

import cs from 'classnames';

import { ReactComponent as CurvedStroke } from 'assets/icons/curvedStroke.svg';

import styles from './SectionTitle.module.scss';

export type SectionTitleColor = 'yellow' | 'blue' | 'white' | 'white-yellow';

interface SectionTitleProps {
  mainText: string;
  highlightText?: string;
  color?: SectionTitleColor;
  textAlign?: 'left' | 'right' | 'center';
  className?: string;
}

const SectionTitle: FC<SectionTitleProps> = ({
  highlightText,
  mainText,
  color = 'blue',
  textAlign = 'left',
  className
}) => (
  <h3
    className={cs(
      styles.title,
      {
        [styles.yellow]: color === 'yellow',
        [styles.blue]: color === 'blue',
        [styles.white]: color === 'white',
        [styles.whiteYellow]: color === 'white-yellow'
      },
      className
    )}
    style={{ textAlign }}
  >
    {highlightText && (
      <span className={styles.stroke}>
        {highlightText}
        <CurvedStroke />
      </span>
    )}{' '}
    {mainText}
  </h3>
);

export default SectionTitle;
